const List = () =>
  import("~/components/Views/Prova/CorrigirQuestaoDiscursiva/List");
const Form = () =>
  import("~/components/Views/Prova/CorrigirQuestaoDiscursiva/Form");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Gerenciamento", link: "" }
];

export const minhasQuestoesDiscursivas = [
  {
    path: "gerenciamento/minhas-questoes-discursivas",
    component: List,
    name: "Minhas Questões Discursivas",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "gerenciamento/corrigir-questao-discursiva/:aplicacaoProvaId",
    component: Form,
    name: "Correção de Questão Discursiva",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path:
      "gerenciamento/corrigir-questao-discursiva/:aplicacaoProvaId/:alunoId",
    component: Form,
    name: "Correção de Questão Discursiva",
    meta: {
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/minhasQuestoesDiscursivas.js